const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/components/Alert/Alert.tsx';
import { css, cx } from '@emotion/css';
import { ReactNode, useMemo } from 'react';
import { ColorSettings, getColorSettings, getIcon, Severity } from '../utils';
import { Alert as MuiAlert, AlertTitle } from '@mui/material';
import { useTheme } from '@mui/material/styles';

interface AlertProps {
    title?: string;
    children?: ReactNode;
    color?: Severity | ColorSettings;
    className?: string;
    hideIcon?: boolean;
}

function useCSSClasses(color: string | undefined, backgroundColor: string | undefined) {
    const theme = useTheme();
    return useMemo(
        () => ({
            // little workaround to get the dialog to have a fixed distance from top and bottom
            className: css`
                display: flex;
                width: 100%;
                flex-direction: row;
                background-color: ${backgroundColor ?? 'transparent'};
                color: ${color ?? 'inherit'};
                height: fit-content;
                border-radius: 4px;
                padding: 6px 16px !important;
                line-height: 20px;
                font-size: 14px;
                overflow: hidden;
                margin-bottom: 8px;
            `,
        }),
        [theme, color, backgroundColor]
    );
}

export const Alert = (props: AlertProps) => {
    const { color, icon, backgroundColor } = getColorSettings('alert', props.color);
    const classes = useCSSClasses(color, backgroundColor);
    const iconElement = !props.hideIcon ? getIcon(icon) : false;
    return (
        <MuiAlert icon={iconElement} className={cx(classes.className, props.className)}>
            {props.title && <AlertTitle>{props.title}</AlertTitle>}
            <div className={'message'}>{props.children}</div>
        </MuiAlert>
    );
};
